import { BrowserRouter as Router, Route, Switch, Link } from "react-router-dom";


import React, { useEffect, useState } from "react";
import {
  Button,
  ButtonGroup,
  Dropdown,
  DropdownButton,
  Form,
  Modal,
} from "react-bootstrap";
import { slide as Menu } from "react-burger-menu";
import Language from "../services/Language.js";
const l = new Language();

const Header = () => {
  const [lang, setLang] = React.useState(l.getLang()||"vi");
  const [isOpen, setOpen] = React.useState(false);
  const [showContact, setShowContact] = React.useState(false);
  const [showGuide, setShowGuide] = React.useState(false);
  var isMenuOpen = function (state) {
    setOpen(state.isOpen);
    return state.isOpen;
  };

  const openContact = (e) => {
    e.preventDefault();
    setOpen(false);
    setShowContact(true);
  };

  const openGuide = (e) => {
    e.preventDefault();
    setOpen(false);
    setShowGuide(true);
  };

  const onLangSelect = (lng) => {
    setLang(lng);
    l.setLang(lng)
    window.location.reload(false);
  };
  return (
    <nav className="navbar navbar-expand-lg navbar-light-hdi bg-light-hdi">
      <a className="navbar-brand" href="#">
        <img src="/img/logo-hdi.svg" alt="HDI" />
        {/*<img className="logo-vj" src="/img/logo-vietjet.png" alt="VJ" />*/}
      </a>
      <button
        className="navbar-toggler"
        onClick={() => setOpen(true)}
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon">
          <i className="fas fa-bars"></i>
        </span>
      </button>

      <div className="collapse navbar-collapse" id="navbarSupportedContent">
        <div className="title-header-placholder"></div>
        <div className="header-r-menu my-2 my-lg-0">
          <DropdownButton
            as={ButtonGroup}
            title={
              <span style={{ paddingRight: 5 }}>
                <i className="fas fa-globe-asia"></i>{l.getLang()=="vi"?l.g('header.langtitle.vi'):l.g('header.langtitle.en')}
              </span>
            }
            className="btn-dropdown-lang"
          >
            <Dropdown.Item
              as="button"
              onSelect={() => onLangSelect("vi")}
              active={lang == "vi"}
              className="drop-item-mn"
            >
              <img src="/img/vi-flag.svg" />
              <div className="text">{l.g('header.langtitle.vi')}</div>{" "}
              {lang == "vi" ? <i className="fas fa-check-circle"></i> : ""}
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item
              as="button"
              onSelect={() => onLangSelect("en")}
              active={lang == "en"}
              className="drop-item-mn"
            >
              <img src="/img/en-flag.svg" />
              <div className="text">{l.g('header.langtitle.en')}</div>{" "}
              {lang == "en" ? <i className="fas fa-check-circle"></i> : ""}
            </Dropdown.Item>
          </DropdownButton>

          <DropdownButton
            as={ButtonGroup}
            title={
              <span style={{ paddingRight: 5 }}>
                <i className="far fa-question-circle"></i>{l.g('header.help.title')}
              </span>
            }
            className="btn-dropdown-lang"
          >
            <Dropdown.Item href="#/action-1" className="drop-item-mn" onClick={openGuide}>
              <img src="/img/hdsd-ic.svg" />
              <div className="text">{l.g('header.help.menu.item1')}</div>{" "}
              <i className="fas fa-chevron-right"></i>
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item href="#/action-3" className="drop-item-mn" onClick={openContact}>
              <img src="/img/lienhe-ic.svg" />
              <div className="text">{l.g('header.help.menu.item3')}</div>
              <i className="fas fa-chevron-right"></i>
            </Dropdown.Item>
          </DropdownButton>
        </div>
      </div>

      <Menu
        isOpen={isOpen}
        width={280}
        right
        customBurgerIcon={false}
        customCrossIcon={false}
        onStateChange={isMenuOpen}
      >
        <div className="lg-mobile">
          <DropdownButton
            as={ButtonGroup}
            title={
              <span style={{ paddingRight: 5 }}>
                <i className="fas fa-globe-asia"></i>{lang=="vi"?l.g('header.langtitle.vi'):l.g('header.langtitle.en')}
              </span>
            }
            className="btn-dropdown-lang"
          >
            <Dropdown.Item
              as="button"
              onSelect={() => onLangSelect("vi")}
              active={lang == "vi"}
              className="drop-item-mn"
            >
              <img src="/img/vi-flag.svg" />
              <div className="text">{l.g('header.langtitle.vi')}</div>
              {lang == "vi" ? <i className="fas fa-check-circle"></i> : ""}
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item
              as="button"
              onSelect={() => onLangSelect("en")}
              active={lang == "en"}
              className="drop-item-mn"
            >
              <img src="/img/en-flag.svg" />
              <div className="text">{l.g('header.langtitle.en')}</div>{" "}
              {lang == "en" ? <i className="fas fa-check-circle"></i> : ""}
            </Dropdown.Item>
          </DropdownButton>
          <div className="btn-close-menu" onClick={() => setOpen(false)}>
            <i className="fas fa-times"></i>
          </div>
        </div>
        <a id="home" className="menu-item" href="/" onClick={openGuide}>
          <img src="/img/hdsd-ic.svg" />
          {l.g('header.help.menu.item1')}
        </a>
        <a id="contact" className="menu-item" href="/" onClick={openContact}>
          <img src="/img/lienhe-ic.svg" />
          {l.g('header.help.menu.item3')}
        </a>
      </Menu>

      <Modal
        show={showContact}
        onHide={() => setShowContact(false)}
        centered
        dialogClassName="contact-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>{l.g('header.help.menu.item3')}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="contact-modal-body">
          <div className="contact-row">
            <span className="contact-icon">
              <i className="fas fa-phone-volume"></i>
            </span>
            <div>
              <div className="contact-title">{l.g('header.help.contact_modal.hotline_label', 'Hotline')}</div>
              <a className="contact-value" href="tel:1900068898">1900068898</a>
            </div>
          </div>
          <div className="contact-row">
            <span className="contact-icon">
              <i className="fas fa-envelope"></i>
            </span>
            <div>
              <div className="contact-title">{l.g('header.help.contact_modal.email_label', 'Email CSKH')}</div>
              <a className="contact-value" href="mailto:cskh@hdinsurance.com.vn">cskh@hdinsurance.com.vn</a>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showGuide}
        onHide={() => setShowGuide(false)}
        centered
        dialogClassName="guide-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>{l.g('header.help.menu.item1')}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="guide-modal-body">
          <div className="guide-section">
            <div className="guide-section-title">{l.g('certificate.quick_search_tab')}</div>
            <ol className="guide-list">
              <li>{l.ghtml('header.help.guide_modal.quick_step1')}</li>
              <li>{l.ghtml('header.help.guide_modal.quick_step2')}</li>
              <li>{l.ghtml('header.help.guide_modal.quick_step3')}</li>
              <li>{l.ghtml('header.help.guide_modal.quick_step4')}</li>
            </ol>
          </div>
          <div className="guide-section">
            <div className="guide-section-title">{l.g('certificate.advanced_search_tab')}</div>
            <ol className="guide-list">
              <li>{l.ghtml('header.help.guide_modal.advanced_step1')}</li>
              <li>{l.ghtml('header.help.guide_modal.advanced_step2')}</li>
              <li>{l.ghtml('header.help.guide_modal.advanced_step3')}</li>
              <li>{l.ghtml('header.help.guide_modal.advanced_step4')}</li>
            </ol>
          </div>
          <div className="guide-tip">{l.ghtml('header.help.guide_modal.tip')}</div>
        </Modal.Body>
      </Modal>
    </nav>
  );
};
export default Header;
